var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayoutVenmo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 27,
    viewBox: "0 0 25 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 25,
    height: 26,
    rx: 12.5,
    fill: "#3D95CE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 10.5C17 12.9911 14.9589 16.2276 13.3018 18.5H9.51823L8 9.04472L11.3134 8.71789L12.1157 15.4455C12.866 14.1724 13.7911 12.1732 13.7911 10.8098C13.7911 10.0634 13.6682 9.55528 13.4766 9.13659L16.4939 8.5C16.8428 9.1 17 9.7187 17 10.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayoutVenmo);
export default __webpack_public_path__ + "static/media/PayoutVenmo.0af270beba2129e047bc6f108d68b8bf.svg";
export { ForwardRef as ReactComponent };